import FontManager from 'ub/fonts/font-service/manager';

export default {
  webFonts: FontManager.addedWebFonts,
  family: 'Arial',
  weight: 400,
  style: 'normal',
  size: 12,
  textStyles: {
    strong: false,
    em: false
  }
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/button/initial-state.js